import { Link } from 'src/components/Link/Link'
import { TextContent } from 'src/components/TextContent'
import { LANDING_ROOT_LINK } from 'src/constants/links'

export const HELP_ITEMS = [
  {
    id: 1,
    title: 'Как отправить посылку',
    text: (
      <TextContent>
        <p>
          Упакуйте посылку правильно, согласно{' '}
          <Link to={`${LANDING_ROOT_LINK}/help/yarcheHowPackShipment`}>требованиям</Link>. Отправьте посылку в указанном
          вами магазине «Ярче».
        </p>
        <ol>
          <li>
            Упакуйте груз (конверт, пакет или короб), учитывая весогабаритные характеристики (ВГХ), заклейте упаковку
            скотчем (не малярным) так, чтобы не было доступа к содержимому;
          </li>
          <li>
            Принесите посылку на кассу магазина «Ярче». Сообщите кассиру, что хотите отправить посылку и покажите
            QR-код, полученный при создании заказа. Передайте упакованный груз кассиру;
          </li>
          <li>Кассир примет груз и наклеит стикер со штрихкодом отправления;</li>
          <li>Оплатите стоимость перевозки на кассе магазина «Ярче»: наличными, банковской картой или по QR-коду.</li>
        </ol>
        <p>
          После сдачи и оплаты посылки в личном кабинете изменится статус заявки. Также вы сможете{' '}
          <Link to={`${LANDING_ROOT_LINK}/tracking`}>отслеживать</Link> статус перевозки в личном кабинете и на сайте
          QP5 Express.
        </p>
      </TextContent>
    )
  },
  {
    id: 2,
    title: 'Правила упаковки посылок',
    text: (
      <TextContent>
        <ol className="title-without-top-m">
          <li> Упакуйте груз (конверт, пакет или короб), учитывая весогабаритные характеристики (ВГХ);</li>
          <li>
            Удалите с упаковки любые этикетки со штрихкодами, если вы используете бывшую в употреблении (б/у) упаковку.
            Если груз хрупкий, то упаковка должна обеспечивать защиту груза при транспортировке;
          </li>
          <li>Заклейте упаковку скотчем (не малярным) так, чтобы исключить доступ к содержимому;</li>
          <li>Убедитесь, что на упаковке есть место для наклеивания этикетки со штрихкодом.</li>
        </ol>
        ВГХ упаковок:
        <ul>
          <li>Конверт А4 из картона (34×27×4 см, до 0,5 кг)</li>
          <li>Пакет А3, курьерский (35×42×20 см, до 3 кг)</li>
          <li>Картонный короб «S» (33×25×15 см, до 5 кг)</li>
          <li>Картонный короб «M» (33×25×30 см, до 10 кг)</li>
          <li>Картонный короб «L» (60×40×40 см, до 20 кг)</li>
        </ul>
        <p className="italic">
          При невыполнении требований к упаковке QP5 Express не несёт ответственности за сохранность принятого к
          перевозке груза.
        </p>
      </TextContent>
    )
  },
  {
    id: 3,
    title: 'Отслеживание посылок',
    text: (
      <TextContent>
        Уточнить статус заявки можно на странице <Link to={`${LANDING_ROOT_LINK}/tracking`}>отслеживания</Link> без
        дополнительной авторизации.
      </TextContent>
    )
  },
  {
    id: 4,
    title: 'Способы оплаты',
    text: (
      <TextContent>На кассе магазина «Ярче» возможна оплата наличными, банковской картой или по QR-коду.</TextContent>
    )
  },
  {
    id: 5,
    title: 'Отмена заказа',
    text: (
      <TextContent>Обратитесь в службу поддержки до отправки посылки о своём намерении отменить заявку. </TextContent>
    )
  },
  {
    id: 6,
    title: 'Грузы запрещенные к перевозке',
    text: (
      <TextContent>
        <p>
          Некоторые грузы запрещено пересылать законодательством Российской Федерации. Ознакомьтесь со{' '}
          <Link to={`${LANDING_ROOT_LINK}/help/yarcheShipmentsCantSent`}>списком грузов, запрещённых к пересылке</Link>.
        </p>
        <p>
          Мы также не сможем переслать грузы, которые превышают допустимые весогабаритные характеристики (ВГХ) упаковок.
        </p>
        <p className="italic">
          QP5 Express не несёт ответственности за то, что в отправлении могут оказаться грузы, запрещённые к пересылке.
        </p>
      </TextContent>
    )
  }
]
